import * as React from "react";
import { connect } from "react-redux";
import { logUI } from "../../../../../api/andyliticsApi";
import * as types from "../../../../../constants/actionTypes";
import Spinner from "../../../../common/spinner";
import { PhoneNumberWithValidation as PhoneNumber, Grid } from "../../../../ecosystem";
import { CareGapsButtons, CareGapsError, CareGapsHeading, CareGapsQuestionHeading } from "../../components";
import CareGapsConfirmationModal from "../../CareGapsConfirmationModal";
import * as procedureType from "../../../../../constants/textConstants";
import * as Tools from "../../../../../helpers/Tools";

class ColorectalCancerSetOne extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {
                pNumber: '',
            },
            pNumberValid: false,
            formValid: false,
            isFailedToPost: false
        };
    }

    componentDidMount() {
        const { careGapsSessionId } = this.props;
        logUI("MBHWeb.UI.ColorectalCancerSetOne.ComponentDidMount", new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
    }

    handleUserInput(fieldName, value) {
        this.setState({
            user: {
                ...this.state.user,
                [fieldName]: value
            },
            [fieldName]: value,
        }, () => { this.validateField(fieldName, value) });
    }
    handleClick = (linkName) => {
        const { updateCareGapFlowFormInputs, history, careGapFlowFormInputs, careGapsSessionId, selectedCareGapOption, postCareGapSetupData, } = this.props;
        logUI(`MBHWeb.UI.ColorectalCancerSetOne.${linkName}.Clicked`, new Date(), Tools.getURLPath(), { ...(careGapsSessionId && { careGapsSessionId: careGapsSessionId }) });
                this.setState({ isFailedToPost: true })
               //history.push('/schedulemyAnnualWellnessVisit/confirmation');
        let formData = this.state.user;
        updateCareGapFlowFormInputs(formData, procedureType.CrC)

        {
            postCareGapSetupData(careGapFlowFormInputs, procedureType.CrC)
        }
    }
    validateField(fieldName, value) {
        let pNumberValid = this.state.pNumberValid;

        switch (fieldName) {
            case 'pNumber':
                pNumberValid = value.match(/^(?!(\d)\(\1{3}\))(?!(\d)\2{9})(?!(\d)\3{2}.\3{3}.\3{4})(?:\(^[2-9]\d{2}\)|^[2-9]\d{2})(.?)?\d{3}\4\d{4}$/);
                break;
            default:
                break;
        }
        this.setState({
            pNumberValid: pNumberValid,
        }, this.validateForm);
    }

    validateForm() {
        const { pNumberValid, user } = this.state;
        this.setState({
            formValid: (pNumberValid)
        });
    }

    componentDidUpdate(prevProps, prevState) {
        // Comparing prevStates to updatedStates
        if (prevProps.postCareGapDataResult !== this.props.postCareGapDataResult) {
            if (this.props.postCareGapDataResult && this.props.postCareGapDataResult.success) {
                this.setState({ isFailedToPost: false })
                this.props.history.push('/schedulemyColorectalCancerscreening/confirmation');
            } else {
                this.setState({ isFailedToPost: true })
            }
        }
    }
    render() {
        const { user, isFailedToPost, pNumber, formValid } = this.state;
        const { postCareGapDataPending } = this.props;
        const showTryAgainError = isFailedToPost && !postCareGapDataPending;
        const nextBtnLabel = showTryAgainError ? 'Try Again' : "Submit";

        const subHeading = "You will be contacted by a care coordinator during our normal business hours (weekdays 8am-4pm) to begin the colorectal screening process.";

        return (
            <Grid fluid className="body-content body-content--no-top-offset care-gaps-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <CareGapsHeading
                            heading="Schedule now"
                            description={subHeading}
                        />
                        <CareGapsQuestionHeading question="Enter you phone number to be contacted." />

                        {postCareGapDataPending && <Spinner />}

                        <div className="row">
                            <div className="col-lg-8 col-xl-6">
                                {showTryAgainError && <CareGapsError />}


                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-lg-8 col-xl-6">


                                <div className="row">
                                    <div className="col-12">
                                        <PhoneNumber
                                            label="Phone number"
                                            id="pNumber"
                                            name="pNumber"
                                            value={pNumber}
                                            required
                                            onChange={(e) => { this.handleUserInput('pNumber', e.target.value); }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <CareGapsButtons
                            prev={{
                                hide: true
                            }}
                            next={{
                                label: nextBtnLabel,

                                disabled: !formValid,
                                onClick: () => this.handleClick(nextBtnLabel)
                            }}
                        />




                    </div>
                </div>
                <CareGapsConfirmationModal careGapsType="schedulemyColorectalCancerscreening" />
            </Grid>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        history: state.session.history,
        postCareGapDataResult: state.careGap.postCareGapDataResult,
        careGapFlowFormInputs: state.careGap.careGapFlowFormInputs,
        postCareGapDataPending: state.careGap.postCareGapDataPending,
        selectedCareGapOption: state.careGap.selectedCareGapOption,
        careGapsSessionId: state.careGap.careGapsSessionId,

    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateCareGapFlowFormInputs: (formInputs, procedureType) => dispatch({ type: types.UPDATE_CAREGAP_FLOW_FORM_INPUTS, formInputs, procedureType }),
        postCareGapSetupData: (careGapData, procedureType) => dispatch({ type: types.POST_CAREGAP_SETUP_DATA, careGapData, procedureType }),

    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ColorectalCancerSetOne);
